import { TwitterOutlined } from '@ant-design/icons';
import { Modal, Tag } from 'antd';
import React, { useEffect, useState } from 'react';
import liracrypt from '../../components/Liracrypt/liracrypt';
import Header from './Header';
import {
    SyncOutlined,
    CloseCircleOutlined,
    ExclamationCircleOutlined,
    LoadingOutlined,
    SolutionOutlined,
    MobileOutlined,
    ControlOutlined,
    AuditOutlined,
  ProfileOutlined,
    FileJpgOutlined
} from "@ant-design/icons";
import KanbanCard from '../../components/KanbanCard';

const FGKanBanBoard = () => {
    const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;

    const [cardModal, setCardModal] = useState({
        show: false,
        id: undefined,
        loading: false
    });
    const [cardData, setCardData] = useState();
    const [responseData, setResponseData] = useState();
    const [configData, setConfigData] = useState();
    useEffect(() => {
        liracrypt.get("/textapi", { dn: 'FgKanbanBoard' })
            .then(({ data }) => {
                setConfigData(data.config);
                setResponseData(data.data);
            })
            .catch(err => {
                console.log(err);
            })
    }, []);

    const toggleModal = (args) => {
        let { show, id, loading } = args || {
            show: false,
            id: undefined,
            loading: false
        };
        setCardModal({
            show,
            id,
            loading
        });
    };

    useEffect(() => {
        if (cardModal.show) {
            liracrypt.get("/textapi", { dn: "SingleKanban", _id: cardModal.id })
                .then(({ data }) => {
                    setCardData(data.data);
                    setCardModal({
                        ...cardModal,
                        loading: false
                    })
                })
                .catch(err => {
                    console.error(err);
                })
        }
    }, [cardModal.show]);

    return (
        <div
            className="dash"
            style={{
                backgroundColor: "rgb(29, 29, 29)",
            }}
        >
            <Header />
            <div>
                <div></div>
                {
                    responseData?.stockSummary && (
                        <div className='custom-wrap'>
                            <div className='customer-count'>
                                {
                                    responseData?.stockSummary?.R && (
                                        <span style={{ backgroundColor: "#c0392b", }}>{responseData?.stockSummary?.R}</span>
                                    )
                                }
                                {
                                    responseData?.stockSummary?.O && (
                                        <span style={{ backgroundColor: "#d35400", }}>{responseData?.stockSummary?.O}</span>
                                    )
                                }
                                {
                                    responseData?.stockSummary?.G && (
                                        <span style={{ backgroundColor: "#27ae60", }}>{responseData?.stockSummary?.G}</span>
                                    )
                                }
                                {
                                    responseData?.stockSummary?.P && (
                                        <span style={{ backgroundColor: "#e84393", }}>{responseData?.stockSummary?.P}</span>
                                    )
                                }
                            </div>
                        </div>
                    )
                }
                {
                    responseData?.rowData && (
                        <div className='fg-custom-table table-responsive'>
                            <table className='table'>
                                <tr className='table_heading'>
                                    <th>Part No</th>
                                    <th>R</th>
                                    <th>O</th>
                                    <th>G</th>
                                    <th>Stock</th>
                                    <th>DOH</th>
                                </tr>
                                {
                                    responseData?.rowData.map((item, i) => (
                                        <tr>
                                            <td>{item.partNo}</td>
                                            <td>{item.R}</td>
                                            <td>{item.O}</td>
                                            <td>{item.G}</td>
                                            <td>{item.stock}</td>
                                            <td>
                                                <table className='inner-table table'>
                                                    <tr>
                                                        <th style={{ backgroundColor: item.bgColDoh }}>{item.doh}</th>
                                                        {
                                                            item.kanban.map((x, index) => (
                                                                <td key={index} style={{ backgroundColor: x.bgColBox, cursor: x.loc ? 'pointer' : '' }}>
                                                                    {
                                                                        x.loc && (
                                                                            <span onClick={() => toggleModal({
                                                                                show: true,
                                                                                id: x._id,
                                                                                loading: true
                                                                            })} style={{ backgroundColor: x.bgColCard }}>
                                                                                <small style={{ fontSize: configData?.kanbanCard?.fontSizeTxt1 }}>{x.txt1}</small>
                                                                                <span style={{ fontSize: configData?.kanbanCard?.fontSizeLoc }}>{x.loc}</span>
                                                                            </span>
                                                                        )
                                                                    }
                                                                </td>
                                                            ))
                                                        }
                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>
                                    ))
                                }
                            </table>
                        </div>
                    )
                }
            </div>
            <Modal cancelButtonProps={{ hidden: true }} okButtonProps={{ hidden: true }} title="KANBAN CARD" style={{ backgroundColor: cardData?.bgColCard || '' }} className='kanban-modal' open={cardModal.show} onOk={toggleModal} onCancel={toggleModal}>
                {
                    cardModal.loading ? (
                        <div style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
                            {antIcon}
                        </div>
                    ) : (
                        <KanbanCard cardData={cardData} />
                    )
                }
            </Modal>
        </div>

    )
};

export default FGKanBanBoard;